export const SOCIALS = [
  {
    id: 'facebook',
    label: 'Facebook',
    href: 'https://www.facebook.com/FPCCIA',
    icon: (
      <path d="M14 9h3V6h-3c-1.7 0-3 1.3-3 3v2H8v3h3v7h3v-7h3l1-3h-4V9c0-.6.4-1 1-1z" />
    ),
  },
  {
    id: 'twitter',
    label: 'X',
    href: 'https://x.com/FPCCIA',
    icon: (
      <path d="M4 4l7.5 9.5L4.5 20H7l5.2-5.7L16.5 20H20l-7.8-9.9L19.5 4H17l-4.7 5.2L8.3 4H4z" />
    ),
  },
];
